/* eslint-disable @typescript-eslint/default-param-last */
import { combineReducers } from 'redux';

import * as types from './types';

export const initState = {};

initState.activeIntegrations = {
  level: null,
  level_id: null,
  value: {
    payment: 'adyen',
    scale: '',
    printer: '',
    cashDrawer: '',
    customerDisplay: '',
  },
};
const activeIntegrations = (
  state = initState.activeIntegrations,
  { type, payload },
) => {
  switch (type) {
    case types.FETCH_ACTIVE_INTEGRATIONS.SUCCESS:
    case types.SAVE_ACTIVE_INTEGRATIONS.SUCCESS:
      return { ...state, ...payload };
    default:
      return state;
  }
};
initState.loader = false;
const loader = (state = initState.loader, { type }) => {
  switch (type) {
    case types.FETCH_ACTIVE_INTEGRATIONS.START:
    case types.SAVE_ACTIVE_INTEGRATIONS.START:
      return true;
    case types.FETCH_ACTIVE_INTEGRATIONS.SUCCESS:
    case types.FETCH_ACTIVE_INTEGRATIONS.ERROR:
    case types.SAVE_ACTIVE_INTEGRATIONS.SUCCESS:
    case types.SAVE_ACTIVE_INTEGRATIONS.ERROR:
      return false;
    default:
      return state;
  }
};

export default combineReducers({ activeIntegrations, loader });
